import { render, staticRenderFns } from "./Step2WhatCanOrder.vue?vue&type=template&id=1536e733"
import script from "./Step2WhatCanOrder.vue?vue&type=script&lang=js"
export * from "./Step2WhatCanOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports